// extracted by mini-css-extract-plugin
export default {"text":"sidebarMenuPayment-module__text__Q7PVW","noteText":"sidebarMenuPayment-module__noteText__+R0Gq"};